import { Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/styles/withStyles/withStyles";

export const SYDM2_SLUG = process.env.LP_SLUG as string;
export const SP_IN_PC_MIN_WIDTH = "365.188px";
export const SP_IN_PC_MAX_WIDTH = "422.391px";

export const lpResponsiveStyles = (
  theme: Theme,
  styleFunc: (baseWidth: string) => CSSProperties
) => {
  return [
    { breakPoint: theme.breakpoints.down("sm"), baseWidth: "100vw" },
    {
      breakPoint: "@media (min-width:960px) and (max-width:1659px)",
      baseWidth: SP_IN_PC_MIN_WIDTH,
    },
    {
      breakPoint: "@media (min-width:1660px) and (max-width:1919px)",
      baseWidth: "22vw",
    },
    { breakPoint: theme.breakpoints.up("xl"), baseWidth: SP_IN_PC_MAX_WIDTH },
  ].reduce(
    (result, map): CSSProperties => ({
      ...result,
      ...{ [map.breakPoint]: styleFunc(map.baseWidth) },
    }),
    {}
  );
};
